import validate from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_6evvvahrfyykd7v3xpopzrfhei/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/src/middleware/auth.global.js";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}